import { render } from "./AddrIcon.vue?vue&type=template&id=087869cb"
import script from "./AddrIcon.vue?vue&type=script&lang=js"
export * from "./AddrIcon.vue?vue&type=script&lang=js"
script.render = render

export default script